module.exports = __webpack_public_path__ + "banquet/components/DownloadBanner/images/banquet-app-icon.dab344617189be907a09c87b1a7e39b7.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/DownloadBanner/images/banquet-app-icon.svg
// module id = 816
// module chunks = 0 1